import React from 'react';
import type { VoyageState } from '../../types/bountifulSea';

// ═══════════════════════════════════════════════════════════════
// VOYAGE TRACKER COMPONENT
// Shows history of declarations in current voyage
// ═══════════════════════════════════════════════════════════════

interface VoyageTrackerProps {
  voyage: VoyageState | null;
  showActualTotals?: boolean;
}

export const VoyageTracker: React.FC<VoyageTrackerProps> = ({
  voyage,
  showActualTotals = false,
}) => {
  if (!voyage) {
    return (
      <div className="bs-voyage-tracker">
        <div className="bs-tracker-title">Voyage Log</div>
        <p style={{ color: 'var(--bs-text-muted)', fontStyle: 'italic', fontSize: '0.9rem' }}>
          Awaiting voyage...
        </p>
      </div>
    );
  }

  return (
    <div className="bs-voyage-tracker">
      <div className="bs-tracker-title">Voyage Log</div>

      {voyage.previousDeclarations.length === 0 ? (
        <p style={{ color: 'var(--bs-text-muted)', fontStyle: 'italic', fontSize: '0.9rem' }}>
          No declarations yet...
        </p>
      ) : (
        voyage.previousDeclarations.map((declared, index) => (
          <div key={index} className="bs-tracker-item">
            <span className="bs-tracker-roll">Roll {index + 1}</span>
            <span className="bs-tracker-declared">{declared} coins</span>
          </div>
        ))
      )}

      <div className="bs-tracker-haul">
        <span className="bs-tracker-haul-label">Current Haul:</span>
        <span className="bs-tracker-haul-value">{voyage.haul} coins</span>
      </div>
    </div>
  );
};

export default VoyageTracker;
